const CLASS_MODAL_OPEN = 'modal-open';

let storedBodyPaddingRight: string | null = null;
let isBodyOverflowing = false;
let scrollbarWidth: number | null = null;

function getScrollbarWidth() {
  if (scrollbarWidth === null) {
    const { body } = document;
    const scrollDiv = document.createElement('div');

    scrollDiv.setAttribute('style', 'position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll;');
    body.appendChild(scrollDiv);
    scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
    body.removeChild(scrollDiv);
  }

  return scrollbarWidth;
}

function updateIsBodyOverflowing() {
  const { body } = document;
  const rect = body.getBoundingClientRect();

  isBodyOverflowing = rect.left + rect.right < window.innerWidth;
}

function prepForModalOpen() {
  const { body } = document;

  updateIsBodyOverflowing();

  if (isBodyOverflowing) {
    // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
    //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
    storedBodyPaddingRight = body.style.paddingRight;
    const calculatedPadding = window.getComputedStyle(body, null).getPropertyValue('padding-right');

    body.style.paddingRight = `${parseFloat(calculatedPadding) + getScrollbarWidth()}px`;
  }

  body.classList.add(CLASS_MODAL_OPEN);
}

function reset() {
  const { body } = document;

  if (storedBodyPaddingRight !== null) {
    body.style.paddingRight = storedBodyPaddingRight;
    storedBodyPaddingRight = null;
  }

  body.classList.remove(CLASS_MODAL_OPEN);
}

function getIsBodyOverflowing() {
  return isBodyOverflowing;
}

export default {
  prepForModalOpen,
  reset,
  getScrollbarWidth,
  getIsBodyOverflowing,
};
